import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import Axios from "axios";
import url from "../../services/url";
import LoadingArea from "../../components/LoadingArea";
import CandidatesTable from "../../components/CandidatesTable";
import isConsultant from "../../services/isConsultant";

function ApplicationList() {
  // States
  const [loading, setLoading] = useState(true);
  const [candidates, setCandidates] = useState([]);

  

  // Effects
  useEffect(() => {
    Axios.get(url("candidates/rejected"),{
      headers:{
        Authorization: `Bearer ${localStorage.getItem("user.token")}`
      }})
      .then((res) => {
        setCandidates(res.data);
        setLoading(false);
      })
      .catch(console.error);
  }, []);

  return (
    <div>
    {!isConsultant() && <Dashboard title="Rejected Candidates">
      <LoadingArea isLoading={loading}>
        <CandidatesTable candidates={candidates} setCandidate={setCandidates} />
      </LoadingArea>
    </Dashboard>}
    </div>
  );
}

export default ApplicationList;
